// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"fd5c2853","455":"f32529e2","977":"4288e1ed"}[chunkId] + ".chunk.js";
};